module.exports = __webpack_public_path__ + "img/arrow-right.30aadc75.svg";